export const SESSION_IDLE_TIMEOUT_SECONDS = 2 * 60 * 60;
export const SESSION_REFRESH_AGE_SECONDS = 5 * 60;

export const SESSION_IDLE_TIMEOUT_MS = SESSION_IDLE_TIMEOUT_SECONDS * 1000;
export const SESSION_REFRESH_AGE_MS = SESSION_REFRESH_AGE_SECONDS * 1000;
export const SESSION_ACTIVITY_STORAGE_KEY = "ops-console:last-activity";

export function parseSessionActivity(value: string | null, now = Date.now()) {
  if (!value) return null;
  const timestamp = Number(value);
  return Number.isFinite(timestamp) && timestamp > 0 && timestamp <= now + 60_000
    ? timestamp
    : null;
}

export function getSessionIdleRemaining(lastActivity: number, now = Date.now()) {
  return Math.min(
    SESSION_IDLE_TIMEOUT_MS,
    Math.max(0, SESSION_IDLE_TIMEOUT_MS - (now - lastActivity)),
  );
}

export function isSessionIdle(lastActivity: number, now = Date.now()) {
  return getSessionIdleRemaining(lastActivity, now) === 0;
}
